<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Constants
	import { CampaignTimeUnits, CampaignTimeUnitLabels } from '@/Constants/Campaigns.js';
	// Components
	import Datepicker from '@/Components/Datepicker.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';
	import PillMultiSelect from '@/Components/PillMultiSelect.svelte';
	/*	import Switch from '@/Components/Switch.svelte';*/

	export let approval_managers = [];
	export let campaign;
	export let errors;
	export let is_update = false;

	let startDate = campaign.publish_date
		? dayjs(campaign.publish_date).format('YYYY-MM-DD')
		: dayjs().format('YYYY-MM-DD');
	let endDate = campaign.end_date
		? dayjs(campaign.end_date).format('YYYY-MM-DD')
		: dayjs().add(1, 'week').format('YYYY-MM-DD');

	$: campaignStart = dayjs(startDate);
	$: campaignEnd = dayjs(endDate);
	$: campaignStart && campaignEnd && updateDateTimes();

	function updateDateTimes() {
		campaign.publish_date = dayjs(campaignStart).format('YYYY-MM-DD');
		campaign.end_date = dayjs(campaignEnd).format('YYYY-MM-DD');
	}
</script>

<div class="flex flex-row w-full pt-1 text-left space-y-4 my-2">
	<span> Campaign ID: <span class="font-semibold">{campaign.campaign_id ?? 'TBA'}</span></span>
</div>
<div class="flex flex-row w-full text-left my-2 space-x-4">
	<TextInput
		label="Campaign Name:  ** CUSTOMER VISIBLE **"
		labelClass="text-nowrap"
		name="name"
		className="w-1/5"
		required
		placeholder="Please enter the campaign name"
		errors={errors && errors.name}
		bind:value={campaign.name}
	/>
	<div class="flex flex-row items-start justify-center">
		<div class="flex flex-col">
			<span class="mb-2 text-nowrap">Campaign Start:</span>
			<Datepicker
				selected={startDate}
				height="42px"
				displayFormat="DD-MM-YYYY"
				dateChosen={(date) => {
					startDate = dayjs(date).format('YYYY-MM-DD');
				}}
				btnStyle="px-5 py-3 border border-gray-300 rounded focus:outline-none focus:border-primary hover:text-dark-grey min-w-[137px]"
			/>
		</div>
	</div>
	<div class="flex flex-col space-y-4">
		<TextInput
			label="Time to start:"
			labelClass="text-nowrap"
			name="time_to_start"
			type="time"
			required
			errors={errors && errors['time_to_start']}
			bind:value={campaign.time_to_start}
		/>
	</div>
	<div class="flex flex-col space-y-4">
		<SelectInput
			className=""
			label="Repeat every"
			name="repeat_type_id"
			labelClass="text-nowrap"
			errors={errors && errors['repeat_type_id']}
			required={true}
			disabled={is_update}
			bind:value={campaign.repeat_type_id}
		>
			<option value={null} selected disabled>Select interval...</option>
			{#each Object.values(CampaignTimeUnits).reverse() as CampaignTimeUnitId}
				{#if CampaignTimeUnitId !== CampaignTimeUnits.HOUR}
					<option value={CampaignTimeUnitId}>{CampaignTimeUnitLabels[CampaignTimeUnitId]}</option>
				{/if}
			{/each}
		</SelectInput>
		<!--		{#if campaign.repeat_type_id !== CampaignTimeUnits.NONE && campaign.repeat_type_id !== null}
			<div class="flex flex-col items-center">
				<span class="mb-3 whitespace-nowrap"> Refresh users on repeat </span>

				<Switch name="refresh_user_list" bind:checked={campaign.refresh_user_list} small={false} readonly={true} disabled={is_update} />
			</div>
		{/if}-->
	</div>
	<div class="flex flex-col space-y-4">
		<SelectInput
			className=""
			label="Offer Valid For Unit"
			labelClass="text-nowrap"
			name="expires_in_unit_id"
			errors={errors && errors['expires_in_unit_id']}
			required={true}
			disabled={is_update}
			bind:value={campaign.expires_in_unit_id}
		>
			<option value={null} selected disabled>Select time unit...</option>
			{#each Object.values(CampaignTimeUnits).reverse() as CampaignTimeUnitId}
				<option value={CampaignTimeUnitId}>{CampaignTimeUnitLabels[CampaignTimeUnitId]}</option>
			{/each}
		</SelectInput>
		{#if campaign.expires_in_unit_id !== CampaignTimeUnits.NONE && campaign.expires_in_unit_id !== null}
			<TextInput
				label={'Expire after # ' + CampaignTimeUnitLabels[campaign.expires_in_unit_id] + 's:'}
				name="expires_in"
				type="number"
				labelClass="text-nowrap"
				placeholder="Value to go with unit"
				errors={errors && errors['expires_in']}
				required={true}
				disabled={is_update}
				bind:value={campaign.expires_in}
			/>
		{/if}
	</div>
	<div class="flex flex-row items-start justify-center">
		<div class="flex flex-col">
			<span class="mb-2 text-nowrap">Campaign End:</span>
			<Datepicker
				selected={endDate}
				displayFormat="DD-MM-YYYY"
				dateChosen={(date) => {
					endDate = dayjs(date).format('YYYY-MM-DD');
				}}
				btnStyle="px-5 py-3 border border-gray-300 rounded focus:outline-none focus:border-primary hover:text-dark-grey min-w-[137px]"
			/>
		</div>
	</div>

	<div class="flex flex-row items-start justify-center">
		<PillMultiSelect
			name="comms"
			label="Comms (SF):"
			altLabel={true}
			singleSelection={false}
			disabled={is_update}
			on:change={(e) => (campaign.comms = e.detail.checked)}
			options={Object.entries({
				email: 'Email',
				sms: 'SMS',
				push: 'Push'
			})}
			checked={campaign.comms}
			action=""
		/>
	</div>
	<SelectInput
		className=""
		label="Approval manager"
		name="approved_by"
		labelClass="text-nowrap"
		disabled={is_update}
		errors={errors && errors['approved_by']}
		bind:value={campaign.approved_by}
	>
		<option value={null} selected>No approval required...</option>
		{#each Object.entries(approval_managers) as approvalManager}
			<option value={approvalManager[0]}>{approvalManager[1]}</option>
		{/each}
	</SelectInput>
</div>
